import { BookOpen, Heart, HelpCircle, Users } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="border-t border-border bg-deep py-12">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <BookOpen className="w-5 h-5 text-primary" />
            <span className="font-display text-lg font-bold">
              Romance<span className="text-primary">Radar</span>
            </span>
          </Link>
          <p className="text-muted-foreground text-sm">
            Your next emotionally addictive romance is one click away.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-foreground">Discover</h4>
          <div className="flex flex-col gap-2">
            <Link to="/discover" className="text-sm text-muted-foreground hover:text-primary transition-colors">Take the Quiz</Link>
            <Link to="/library" className="text-sm text-muted-foreground hover:text-primary transition-colors">Browse Library</Link>
            <Link to="/new-releases" className="text-sm text-muted-foreground hover:text-primary transition-colors">New Releases</Link>
            <Link to="/coming-soon" className="text-sm text-muted-foreground hover:text-primary transition-colors">Coming Soon</Link>
            <Link to="/authors" className="text-sm text-muted-foreground hover:text-primary transition-colors">Authors</Link>
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-foreground">Browse by</h4>
          <div className="flex flex-col gap-2">
            <Link to="/tropes" className="text-sm text-muted-foreground hover:text-primary transition-colors">Romance Tropes</Link>
            <Link to="/genres" className="text-sm text-muted-foreground hover:text-primary transition-colors">Subgenres</Link>
            <Link to="/tropes/enemies-to-lovers" className="text-sm text-muted-foreground hover:text-primary transition-colors">Enemies to Lovers</Link>
            <Link to="/tropes/fated-mates" className="text-sm text-muted-foreground hover:text-primary transition-colors">Fated Mates</Link>
            <Link to="/genres/dark-romance" className="text-sm text-muted-foreground hover:text-primary transition-colors">Dark Romance</Link>
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-foreground">Stay Connected</h4>
          <div className="flex flex-wrap gap-2">
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 bg-secondary text-secondary-foreground border border-border px-4 py-2 rounded-full text-sm font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <HelpCircle className="w-4 h-4" /> FAQ
            </Link>
            <Link
              to="/community"
              className="inline-flex items-center gap-1.5 bg-secondary text-secondary-foreground border border-border px-4 py-2 rounded-full text-sm font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <Users className="w-4 h-4" /> Community
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-border mt-8 pt-6 text-center text-sm text-muted-foreground">
        Made with <Heart className="w-3 h-3 inline text-primary" /> for romance readers everywhere
      </div>
    </div>
  </footer>
);

export default Footer;
